export const GET_NETWORKS_DEVICES = "GET_NETWORKS_DEVICES";
export const GET_NETWORK_DEVICE_TOKEN = "GET_NETWORK_DEVICE_TOKEN";
export const GET_SINGLE_NETWORKS_DEVICES = "GET_SINGLE_NETWORKS_DEVICES";
export const GET_ALL_NETWORK_LOCATIONS = "GET_ALL_NETWORK_LOCATIONS";
export const GET_SINGLE_NETWORK_LOCATION = "GET_SINGLE_NETWORK_LOCATION";
export const DELETE_NETWORK = "DELETE_NETWORK";
export const SAVE_NETWORK_CREDENTIALS = "SAVE_NETWORK_CREDENTIALS";
export const INITIALIZE_RESCAN = "INITIALIZE_RESCAN";